// The preview is a local development surface, never a production feature switch.
export const isStaffManagementPreviewEnabled = () => (
    process.env.NODE_ENV === "development" &&
    process.env.REACT_APP_STAFF_MANAGEMENT_PREVIEW === "true"
);
